import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module list/todolist/todolistui
 */
import { createUIComponent } from '../list/utils.js';
import { icons, Plugin } from 'ckeditor5/src/core.js';
/**
 * The to-do list UI feature. It introduces the `'todoList'` button that
 * allows to convert elements to and from to-do list items and to indent or outdent them.
 */
var TodoListUI = /*#__PURE__*/function (_Plugin) {
  _inherits(TodoListUI, _Plugin);
  var _super = _createSuper(TodoListUI);
  function TodoListUI() {
    _classCallCheck(this, TodoListUI);
    return _super.apply(this, arguments);
  }
  _createClass(TodoListUI, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var t = this.editor.t;
      createUIComponent(this.editor, 'todoList', t('To-do List'), icons.todoList);
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'TodoListUI';
    }
  }]);
  return TodoListUI;
}(Plugin);
export { TodoListUI as default };